export default function XML_DOM() {
  return (
    <div>
      <h1>XML_DOM</h1>
      <p>This is the XML_DOM component.</p>
    </div>
  );
}